import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export function observeWalletBalance(userId, cb) {
    const ref = doc(db, 'wallets', userId);
    return onSnapshot(ref, (snap) => cb(snap.exists() ? snap.data()?.balance || 0 : 0));
}
